import {
  experimental_ComboboxField as ComboboxField,
  experimental_ComboboxPopover as ComboboxPopover,
  experimental_useComboboxState as useComboboxState,
} from '@vtex/admin-ui'
import { getErrorText, hasError, useWatch } from '@vtex/admin-ui-form'
import { usePriceTables } from 'hooks'
import { useEffect, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { search } from 'ui'
import { FieldDetails } from 'ui/components/FieldDetails'
import { DEBOUNCE_TIMEOUT } from 'ui/components/PromotionForm/Sellers/OptIn/Table'
import { SettingsProps } from '../../../hooks/useGenericComponent'
import { messages } from './messages'
import { styles } from './styles'

const MAX_OPTIONS = 10

export function PriceTableEditor(props: SettingsProps) {
  const { state } = props

  const value: string | undefined = useWatch({ form: state, name: 'value' })

  const { $t } = useIntl()

  const { data } = usePriceTables()

  const options = useMemo(
    () => (data ? data.sort((a, b) => a.localeCompare(b)) : []),
    [data]
  )

  const combobox = useComboboxState({
    timeoutMs: DEBOUNCE_TIMEOUT,
    virtualFocus: true,
  })

  useEffect(() => {
    if (combobox.deferredValue === '') {
      combobox.setMatches([])
    } else {
      combobox.setMatches(
        search(options, combobox.deferredValue).slice(0, MAX_OPTIONS)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [combobox.deferredValue])

  useEffect(() => {
    if (value && combobox.value !== value) combobox.setValue(value)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  useEffect(() => {
    if (combobox.value !== value) state.setValue('value', combobox.value)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [combobox.value])

  return (
    <div className={styles.flex}>
      <ComboboxField
        id="value"
        label={$t(messages.editor.label)}
        state={combobox}
        className={styles.field}
        onClick={() => combobox.setMatches(options.slice(0, MAX_OPTIONS))}
        data-error={hasError(state, 'value')}
      />
      <ComboboxPopover state={combobox} />
      <FieldDetails.Error text={getErrorText(state, 'value')} />
      <FieldDetails.Help text={$t(messages.editor.helpText)} />
    </div>
  )
}
